export enum LessonsIconLable {
    NONE = '',
    PLUS_FOLDER = 'plus_folder',
    PENCIL = 'pencil',
    PLUS = 'plus',
    SHIELD = 'shield',
    CONVERSATION = 'conversation'
}